import React from 'react';
import './CustomBarChart.scss';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Cell,
} from "recharts";

const CustomBarChart = ({ data, title }) => {

  const colors = [
    "#FDB97C",
    "#F89170",
    "#F89370",
    "#F36162",
    "#EF495A",
    "#73B791",
    "#6BA395",
    "#618D98",
    "#58769C",
    "#4E5FA0",
    "#CF41A7",
    "#BD3BB8",
  ];

  return (
    <div className="cbarchart-wrapper">
      <h2>{title}</h2>
      <div className="cbarchart-inner">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            barCategoryGap="10%"
            margin={{ top: 10, right: 10, left: -20, bottom: 15 }}
            barGap="15px"
          >
            <CartesianGrid vertical={false} strokeDasharray="0" stroke="#D9D9D9" />
            <XAxis
              tick={{ fontSize: 12, fontFamily: "IRANSans", dy: 12 }}
              interval={0}
              angle={-30}
              dataKey="name"
              axisLine={false}
              tickLine={false}
            />
            <YAxis
              tickFormatter={(tick) => tick.toLocaleString('fa-IR')}
              domain={[0, data && data.length > 0 ? "auto" : 100]}
              tick={{ fontSize: 12, fontFamily: "IRANSans" }}
              tickCount={3}
              axisLine={false}
              tickLine={false}
              dx={-26}
            />
            <Bar dataKey="uv" barSize={3.5}>
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default CustomBarChart;
